// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body.b2b-lib-overlay{background:unset;overflow-y:hidden !important}.b2b-lib-click_to_call .b2b-lib-modalContent{min-height:auto;margin:auto}.b2b-lib-click_to_call .b2b-lib-content_scroll{width:100%}.b2b-lib-click_to_call .b2b-lib-modalBody{height:100%;display:flex;padding:var(--spacing-xl) 0 !important}.b2b-lib-click_to_call .b2b-lib-outlinebtn,.b2b-lib-click_to_call .b2b-lib-activebtn{text-transform:unset}\n", ""]);
// Exports
exports.locals = {
	"click_to_call": "b2b-lib-click_to_call",
	"outlinebtn": "b2b-lib-outlinebtn",
	"activebtn": "b2b-lib-activebtn"
};
module.exports = exports;
